var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5584 15.8841H7.89176C5.2501 15.8841 3.1001 13.7341 3.1001 11.0924C3.1001 8.45078 5.2501 6.30078 7.89176 6.30078H17.0584C17.4001 6.30078 17.6834 6.58411 17.6834 6.92578C17.6834 7.26745 17.4001 7.55078 17.0584 7.55078H7.89176C5.94176 7.55078 4.3501 9.14245 4.3501 11.0924C4.3501 13.0424 5.94176 14.6341 7.89176 14.6341H14.5584C14.9001 14.6341 15.1834 14.9174 15.1834 15.2591C15.1834 15.6008 14.9084 15.8841 14.5584 15.8841Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1415 9.63372C14.9831 9.63372 14.8248 9.57539 14.6998 9.45039C14.4581 9.20872 14.4581 8.80872 14.6998 8.56706L16.3915 6.87539L14.6998 5.18372C14.4581 4.94206 14.4581 4.54206 14.6998 4.30039C14.9415 4.05872 15.3415 4.05872 15.5831 4.30039L17.7165 6.43372C17.9581 6.67539 17.9581 7.07539 17.7165 7.31706L15.5831 9.45039C15.4581 9.57539 15.2998 9.63372 15.1415 9.63372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.6fc56cc3971bacf4820b300045efd636.svg";
export { ForwardRef as ReactComponent };